/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const HourGlassCircle: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path d='M10 5V4H6V5C6 5.95015 6.47705 6.47639 8.00002 7.41403C9.52271 6.47665 10 5.95039 10 5Z' />
			<path d='M6 11.601C6.45258 11.2645 7.09585 11 8 11C8.90415 11 9.54742 11.2645 10 11.601V11C10 10.0488 9.52282 9.52205 7.99998 8.58434C6.47741 9.52179 6 10.0486 6 11V11.601Z' />
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M0 8C0 3.6 3.6 0 8 0C12.5 0 16 3.6 16 8C16 12.4 12.4 16 8 16C3.6 16 0 12.4 0 8ZM5 4H4V3H12V4H11V5C11 6.30838 10.4466 7.02295 8.94594 7.99919C10.4463 8.97532 11 9.69051 11 11V12H12V13H4V12H5V11C5 9.69078 5.5535 8.97562 7.05406 7.99923C5.55361 7.02324 5 6.30865 5 5V4Z'
			/>
		</Svg>
	);
};

export { HourGlassCircle };
